export default __webpack_public_path__ + "images/PZ.5fec12a.png";